<script setup>
import Skeleton from '@/design-system/components/atoms/Skeleton.vue';
</script>

<template>
  <div
    class="usage-bars-skeleton"
    role="status"
    aria-label="Carregando créditos..."
  >
    <div class="usage-bars-skeleton__item">
      <div class="usage-bars-skeleton__header">
        <Skeleton width="48px" height="0.75rem" border-radius="2px" />
        <Skeleton width="56px" height="0.75rem" border-radius="2px" />
      </div>
      <Skeleton width="100px" height="6px" border-radius="3px" />
    </div>
    <div class="usage-bars-skeleton__item">
      <div class="usage-bars-skeleton__header">
        <Skeleton width="48px" height="0.75rem" border-radius="2px" />
        <Skeleton width="56px" height="0.75rem" border-radius="2px" />
      </div>
      <Skeleton width="100px" height="6px" border-radius="3px" />
    </div>
  </div>
</template>

<style scoped>
.usage-bars-skeleton {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}

.usage-bars-skeleton__item {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.usage-bars-skeleton__header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100px;
  gap: var(--spacing-xs);
}
</style>
